import { $, owlCarousel } from "./imports";

const featurDetProdCarousel = () => {

    let $featuresDetCarousel = $('.product-features__list .field__items');
    let timeoutfeatDetCarousel = false;

    function initFeaturesDetCarousel() {
        $featuresDetCarousel.addClass('owl-carousel').owlCarousel({
            nav: false,
            dots: false,
            margin: 50,
            navText: [
                '<svg xmlns="http://www.w3.org/2000/svg" width="8.551" height="13.847" viewBox="0 0 8.551 13.847"><path d="M15.514,6l1.627,1.627-5.285,5.3,5.285,5.3-1.627,1.627L8.59,12.923Z" transform="translate(-8.59 -6)" fill="#3c271a"/></svg>',
                '<svg xmlns="http://www.w3.org/2000/svg" width="8.551" height="13.847" viewBox="0 0 8.551 13.847"><path d="M10.217,6,8.59,7.627l5.285,5.3L8.59,18.22l1.627,1.627,6.923-6.923Z" transform="translate(-8.59 -6)" fill="#3c271a"/></svg>'
            ],
            // rewind: true,
            loop: true,
            // items: 6,
            autoplay: true,
            autoplayTimeout: 8000,
            autoplayHoverPause: true,
            stagePadding: 150,
            autoWidth: true,
            center: true,
        });
    }

    function destroyFeaturesDetCarousel() {
        $featuresDetCarousel.trigger("destroy.owl.carousel").removeClass("owl-carousel");
    }

    function showFeaturesDetCarousel() {
        if ($featuresDetCarousel.data("owlCarousel") !== "undefined") {
            if (window.matchMedia('(min-width: 992px)').matches) {
                initFeaturesDetCarousel();
            } else {
                destroyFeaturesDetCarousel();
            }
        }
    }

    if ($featuresDetCarousel.length > 0) {
        /*==================== WINDOW RESIZE ====================*/
        window.addEventListener('resize', function () {
            this.clearTimeout(timeoutfeatDetCarousel);
            timeoutfeatDetCarousel = this.setTimeout(showFeaturesDetCarousel(), 250);
        });

        showFeaturesDetCarousel();

    }
};

export default featurDetProdCarousel;